'use strict';exports.__esModule = true;exports.hideProjectPropertyLightbox = exports.openProjectPropertyLightbox = exports.receiveProjectProperties = undefined;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');
var _formatApiError = require('../../helpers/formatApiError');var _formatApiError2 = _interopRequireDefault(_formatApiError);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

promise = _reduxLoop.Effects.promise;

var receiveProjectProperties = (0, _reduxAct.createAction)('/RECEIVE_PROJECT_PROPERTIES');
var receiveProjectPropertiesSuccess = (0, _reduxAct.createAction)('/RECEIVE_PROJECT_PROPERTIES_SUCCESS');
var receiveProjectPropertiesFail = (0, _reduxAct.createAction)('/RECEIVE_PROJECT_PROPERTIES_FAIL');
var openProjectPropertyLightbox = (0, _reduxAct.createAction)('/OPEN_PROJECT_PROPERTY_LIGHTBOX');
var hideProjectPropertyLightbox = (0, _reduxAct.createAction)('/HIDE_PROJECT_PROPERTY_LIGHTBOX');

var initialState = {
  loading: false,
  loaded: false,
  isProjectPropertyLightboxOpen: false,
  data: [] };


var receiveHandlerSuccess = function receiveHandlerSuccess(state, response) {return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    data: response.data });};


var receiveHandlerFail = function receiveHandlerFail(state, action) {
  var error = (0, _formatApiError2.default)(action, 'Error while loading project properties');
  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    error: error });

};

var fetchReceive = function fetchReceive(id) {return _axios2.default.get('projects/' + id + '/properties').
  then(receiveProjectPropertiesSuccess, receiveProjectPropertiesFail);};

var receiveHandler = function receiveHandler(state, id) {return (0, _reduxLoop.loop)(Object.assign({}, state, { loading: true }), promise(fetchReceive, id));};

var handleOpenProjectPropertyLightbox = function handleOpenProjectPropertyLightbox(state) {return Object.assign({},
  state, {
    isProjectPropertyLightboxOpen: true });};


var handleHideProjectPropertyLightbox = function handleHideProjectPropertyLightbox(state) {return Object.assign({},
  state, {
    isProjectPropertyLightboxOpen: false });};


var projectProperties = (0, _reduxAct.createReducer)(function (on) {
  on(receiveProjectProperties, receiveHandler);
  on(receiveProjectPropertiesSuccess, receiveHandlerSuccess);
  on(receiveProjectPropertiesFail, receiveHandlerFail);
  on(openProjectPropertyLightbox, handleOpenProjectPropertyLightbox);
  on(hideProjectPropertyLightbox, handleHideProjectPropertyLightbox);
}, initialState);exports.


receiveProjectProperties = receiveProjectProperties;exports.
openProjectPropertyLightbox = openProjectPropertyLightbox;exports.
hideProjectPropertyLightbox = hideProjectPropertyLightbox;exports.default =


projectProperties;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/projectProperties.js
// module id = 597
// module chunks = 0